import styled from 'styled-components';
import Label from 'common/Label';

const StyledLabel = styled(Label)``;

export default StyledLabel;
